import React from 'react';

export const YanaAvatarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="20" cy="20" r="20" fill="#E0E7FF"/>
        <path d="M17.3333 12L19.3333 16L17.3333 20L15.3333 16L17.3333 12Z" fill="#4F46E5"/>
        <path d="M22.6667 18.6667L24 20.6667L22.6667 22.6667L21.3333 20.6667L22.6667 18.6667Z" fill="#4F46E5"/>
    </svg>
);
